export default "__VITE_ASSET__CNeKLSPV__"